import React from 'react';
import { Box, IconButton } from '@mui/material';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { LruHistoryPanelProps, LruToggleButtonProps } from './types';
import HistoryQCField from '50.quickConnect.Fields/FieldsTypes/Others/HistoryQC';

export const LruToggleButton = ({ disabled, hasItems, onClick }: LruToggleButtonProps) => {
  if (!hasItems) return null;

  return (
    <IconButton edge="end" onClick={onClick} disabled={disabled}>
      <ManageSearchIcon />
    </IconButton>
  );
};

export const LruHistoryPanel = ({
  disabled,
  show,
  list,
  onTagChange,
  handleDeleteItem,
  fieldFullId,
}: LruHistoryPanelProps) => {
  if (!show) return null;

  return (
    <Box>
      <HistoryQCField
        disabled={disabled}
        prevValue={list}
        onTagChange={onTagChange}
        handleDeleteItem={handleDeleteItem}
        fieldFullId={fieldFullId}
      />
    </Box>
  );
};
